import React from 'react';
import { useFormContext } from 'react-hook-form';
import { Box, Checkbox, Text } from '@chakra-ui/react';
import { cx } from '@chakra-ui/utils';

import type { InputControlProps } from './types';

export const CheckboxControl = React.forwardRef<HTMLInputElement, any>(
  (
    {
      name,
      label,
      helper,
      error,
      isDisabled,
      isRequired,
      rules,
      ...props
    }: InputControlProps,
    forwardRef,
  ) => {
    const { register } = useFormContext();
    const { ref: inputRef, ...rest } = register(name, { ...rules });

    const mergedRef = (e: any) => {
      inputRef(e);
      if (forwardRef) (forwardRef as any).current = e;
    };

    return (
      <Box>
        <Checkbox
          className={cx('Checkbox')}
          {...rest}
          ref={mergedRef}
          isInvalid={!!error}
          isDisabled={isDisabled}
          isRequired={isRequired}
          onChange={(e: any) => {
            if (props.onChange) props.onChange(e.target.checked);
          }}
        >
          <Text color={error ? 'red' : ''}>{label}</Text>
        </Checkbox>
        {helper && !error && (
          <Text fontSize="sm" className={cx('InputHelper')}>
            {helper}
          </Text>
        )}
        {error && typeof error === 'string' && (
          <Text fontSize="sm" color="red" className={cx('InputError')}>
            {error}
          </Text>
        )}
      </Box>
    );
  },
);
